<!-- ItemMenu.svelte -->
<script>
  import { Menu } from "@svelteuidev/core";
  import Navigate from "../Classes/Navigate";
  import { permissaoUsuario } from "../Classes/Stores";
  import { logado, atualizarLogado } from "../Classes/EstadoLogado";
  import { createEventDispatcher, onMount } from "svelte";
  import Constantes from "../Classes/Constantes";

  let navi = new Navigate();
  const dispatch = createEventDispatcher();
  let logadoValor = false;
  export let item = {};

  // Assine as mudanças no valor de logado
  const unsubscribe = logado.subscribe((value) => {
    logadoValor = value;
  });

  onMount(() => {
    // Limpe a assinatura quando o componente for destruído para evitar vazamentos de memória
    return unsubscribe;
  });

  function NavegarPara(item) {
    if (item.logout) {
      localStorage.setItem("token", "");
      localStorage.setItem("usuario", "");
      localStorage.setItem("id_empresa", "");
      Constantes.logado = false;
      atualizarLogado(false);

      navi.goTo("/");
    } else {
      navi.goTo(item.navegarPara);
    }
    dispatch("close");
  }
</script>

{#if (item.SoLogado == false && item.login != true) || ((item.SoLogado == false || (item.SoLogado && $logado)) && item.login != true && $logado)}
  {#if item.permissao == "" || item.SoLogado == false || ($permissaoUsuario && (item.permissao in $permissaoUsuario.permissoes || $permissaoUsuario.permissoes.includes(item.permissao)))}
      <Menu.Item on:click={() => NavegarPara(item)}>
        {#if item.icone}
          <i class={item.icone}></i>
        {/if}
        {item.nome}
      </Menu.Item>
    
  {/if}
{:else if item.login == true && !$logado}
  
    <Menu.Item on:click={() => NavegarPara(item)}>
      {#if item.icone}
        <i class={item.icone}></i>
      {/if}
      {item.nome}
    </Menu.Item>
  
{/if}
